<!--
 * @Description: 供应商销售排行榜
 * @Author: xiawenlong
 * @Date: 2021-07-13 09:17:17
 * @LastEditors: xiawenlong
 * @LastEditTime: 2026-02-09 12:46:01
-->

<template>
  <div class="SupplierSales">
    <div class="title">
      <img src="@/img/datav/title_icon.png" alt="" />
      <span>供应商销售排行榜</span>
    </div>
    <vue-seamless-scroll :data="data" :class-option="scrollOption" class="ranking-list">
      <div
        v-for="(item, index) in data"
        :key="index"
        class="ranking-card"
        :class="'rank-' + (index + 1) + (visibleItems.includes(index) ? ' is-visible' : '')"
        :style="{ animationDelay: index * 100 + 'ms' }"
      >
        <!-- 背景进度条 -->
        <div class="bg-progress" :style="{ width: (item.amount / maxAmount) * 100 + '%' }"></div>

        <div class="card-content">
          <div class="rank-badge">{{ index + 1 }}</div>
          <div class="name">{{ item.orgName }}</div>
          <div class="amount">{{ item.amount }} <span class="unit">万元</span></div>
        </div>
      </div>
    </vue-seamless-scroll>
  </div>
</template>

<script>
import { supplierSale } from '@/api/dashboard'
import to from 'await-to'

export default {
  data() {
    return {
      scrollOption: {
        step: 0.6,
        limitMoveNum: 4,
        hoverStop: true,
        direction: 1,
        openWatch: true,
        singleHeight: 0,
        singleWidth: 0,
        waitTime: 0,
      },
      type: 3,
      maxAmount: 9256,
      visibleItems: [],
      data: [
        { orgName: '广水市致信运营管理有限公司', amount: 9256 },
        { orgName: '广水市胜时运营管理有限公司', amount: 7896 },
        { orgName: '广水市农芸运营管理有限公司', amount: 6665 },
        { orgName: '广水市犇农运营管理有限公司', amount: 6005 },
        { orgName: '广水市颂财运营管理有限公司', amount: 5166 },
        { orgName: '广水市步鑫运营管理有限公司', amount: 4625 },
      ],
    }
  },
  mounted() {
    this.initData()
    setInterval(() => {
      this.initData()
    }, process.env.VUE_APP_LTIME)
  },
  methods: {
    async initData() {
      const [res, err] = await to(
        supplierSale({
          type: this.type,
        }),
      )
      if (err) return
      this.data = res.data
      this.maxAmount = Math.max(...res.data.map(item => item.amount))
      this.triggerEnterAnimation()
    },
    typeChange(type) {
      this.type = type
      this.initData()
    },
    triggerEnterAnimation() {
      this.data.forEach((_, index) => {
        setTimeout(() => {
          this.visibleItems.push(index)
        }, index * 100)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.SupplierSales {
  position: relative;
  height: 100%;
  box-sizing: border-box;
  padding: 20px 30px;

  .title {
    width: 550px;
    position: relative;
    font-size: 26px;
    color: #ecf8ff;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    img {
      margin-right: 3px;
    }
  }

  .ranking-list {
    box-sizing: border-box;
    height: calc(100% - 60px);
    overflow: hidden;
    will-change: transform;

    .ranking-card {
      position: relative;
      margin-bottom: 12px;
      border-radius: 12px;
      overflow: hidden;
      transition: all 0.3s ease;
      opacity: 0;
      transform: translateX(-20px);
      border: 1px solid rgba(0, 245, 255, 0.15);

      &.is-visible {
        animation: slideIn 0.5s ease forwards;
      }

      &:hover {
        transform: translateX(8px);
        border-color: rgba(0, 245, 255, 0.3);

        .bg-progress {
          opacity: 0.35;
        }
      }

      // 背景进度条
      .bg-progress {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        background: linear-gradient(
          90deg,
          rgba(0, 102, 255, 0.4) 0%,
          rgba(0, 204, 255, 0.5) 50%,
          rgba(0, 245, 255, 0.4) 100%
        );
        border-radius: 12px;
        transition: width 1s ease, opacity 0.3s ease;
        opacity: 0.45;
        z-index: 0;
      }

      // 卡片内容
      .card-content {
        position: relative;
        z-index: 1;
        display: flex;
        align-items: center;
        padding: 8px 20px;
      }

      .rank-badge {
        width: 40px;
        height: 40px;
        min-width: 40px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 16px;
        font-size: 16px;
        font-weight: 700;
        color: #fff;
        background: linear-gradient(135deg, rgba(0, 102, 255, 0.8) 0%, rgba(0, 245, 255, 0.6) 100%);
        box-shadow: 0 4px 15px rgba(0, 102, 255, 0.4);
      }

      &.rank-1 .rank-badge {
        background: linear-gradient(135deg, #ffd700 0%, #ff6b35 100%);
        box-shadow: 0 4px 20px rgba(255, 215, 0, 0.5);
      }

      &.rank-2 .rank-badge {
        background: linear-gradient(135deg, #c0c0c0 0%, #a0a0a0 100%);
        box-shadow: 0 4px 20px rgba(192, 192, 192, 0.5);
      }

      &.rank-3 .rank-badge {
        background: linear-gradient(135deg, #cd7f32 0%, #b87333 100%);
        box-shadow: 0 4px 20px rgba(205, 127, 50, 0.5);
      }

      .name {
        flex: 1;
        min-width: 0;
        font-size: 20px;
        font-weight: 500;
        color: #e8f4ff;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-right: 16px;
      }

      .amount {
        font-size: 22px;
        font-weight: 700;
        background: linear-gradient(135deg, #00f5ff 0%, #0066ff 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        font-family: 'DIN Alternate', 'Roboto Mono', monospace;

        .unit {
          font-size: 14px;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.5);
          -webkit-text-fill-color: rgba(255, 255, 255, 0.5);
          margin-left: 4px;
        }
      }
    }
  }
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@media (max-width: 1440px) {
  .SupplierSales {
    padding: 16px 20px;

    .title {
      margin-bottom: 16px;
    }

    .ranking-list {
      .ranking-card {
        margin-bottom: 10px;

        .card-content {
          padding: 6px 16px;
        }

        .rank-badge {
          width: 36px;
          height: 36px;
          min-width: 36px;
          font-size: 14px;
          margin-right: 12px;
        }

        .name {
          font-size: 18px;
          margin-right: 12px;
        }

        .amount {
          font-size: 20px;

          .unit {
            font-size: 12px;
          }
        }
      }
    }
  }
}
</style>
